import { ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

export default function ModalBackButton({
  previousStep,
  canGoBack,
}: {
  previousStep: () => void;
  canGoBack: boolean;
}) {
  if (!canGoBack) {
    return null;
  }

  return (
    <ActionIcon
      variant="subtle"
      onClick={previousStep}
      style={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 9000,
      }}
    >
      <IconArrowLeft color="white" />
    </ActionIcon>
  );
}
